/**
 * Millisecond constants.
 * @private
 */

const SECOND = 1000
const MINUTE = 60 * SECOND
const HOUR   = 60 * MINUTE
const DAY    = 24 * HOUR

export { SECOND, MINUTE, HOUR, DAY }

/**
 * Get time in milliseconds.
 * @param {string} [date]
 * @returns {number}
 */
export const getTime = (date = null) => {
  const time = date
    ? new Date(date).getTime()
    : Date.now()
  return time
}

/**
 * Get time diff.
 * @param {Date}   from
 * @param {Date}   [to]
 * @param {number} [type]
 * @returns {string}
 */
export const getDiff = (from, to = new Date(), type = DAY) => {
  const diff = getTime(from) - getTime(to)
  const left = ~~(diff / type)
  return left
}

/**
 * Format to brazilian date format.
 * @param {(Date|string|number)} date
 * @returns {string}
 */
export const formatDate = (date) => {
  const formatted = new Date(date).toLocaleDateString('pt-BR')
  return formatted
}



// WEBPACK FOOTER //
// ./src/helpers/time.js